module.exports = __webpack_public_path__ + "img/spice-money-paymentservices.acc5fd0c.png";